import React from 'react';
import vr from '../../../../utils/Verifiers';
import CloseButton from '../../../sharecomponents/CloseButton';
import { dateFormatConDiaYHoraShort } from '../../../../utils/DateFunctions';

const HistorialProyecciones = (p) => {
    const data = p?.data?.historico ?? [];
    const bloque = p.data?.bloque ?? "";
    const semana = p?.data?.semana ?? '';
    const dia = p?.data?.dia ?? '';
    const tallos = p?.data?.tallos ?? 0;
    const close = p.close ?? (() => { });

    return (
        <div className='col-lg-12 text-center blur-m bg-white4 vw-100 vh-100' style={vr.floatPageStyle()}>
            <div className='row justify-content-center w-100 m-0 p-0'>
                <CloseButton close={() => close()} />
                <div className='bw-1000 mt-5 p-3 rounded bg-white3 shadow'>
                    <div className="w text-center h4 text-300" style={{ '--w': '100%' }}>
                        {bloque} <span className='text-m text-bold text-secondary ps-2 italic mb-3'>Historial de proyecciones</span>
                    </div>
                    <table className='table table-sm table-hover'>
                        <thead>
                            <tr>
                                <th scope='col' className='upper'>Fecha de ajuste</th>
                                <th scope='col' className='upper'>Usuario</th>
                                <th scope='col' className='upper'>Días ciclo</th>
                                <th scope='col' className='upper'>Semana</th>
                                <th scope='col' className='upper'>Tallos</th>
                                <th scope='col' className='upper'>Dif. Días/Tallos</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((reg, i) =>
                                <tr key={i}>
                                    <td className='text-m text-center'>{dateFormatConDiaYHoraShort(reg.fecha)}</td>
                                    <td className='text-m text-center'>{reg.usuario}</td>
                                    <td className='text-m text-center'>{reg.dias_campo_proyectado}</td>
                                    <td className='text-m text-center'>{reg.semana}-{reg.dia}</td>
                                    <td className='text-m text-center'>{reg.tallos}</td>
                                    <td className='text-m text-center'>{reg.diff_dias_anterior}/{reg.diff_tallos_anterior}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default HistorialProyecciones;